export default __webpack_public_path__ + "static/media/403b_dark.6d015717.png";